import { render, staticRenderFns } from "./header-user.vue?vue&type=template&id=6e41fa50"
import script from "./header-user.vue?vue&type=script&lang=js"
export * from "./header-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports